const bannerStore = (apiServices => ({
  // May get the banner message from JanPress later down the track.
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    bannerOpen: false,
  },
  mutations: {
    // sync
    changeState: (state, flag) => {
      state.bannerOpen = flag;
    },
  },
  actions: {
    // async/sync
    changeState: (context, flag) => {
      context.commit('changeState', flag);
    }
  },
  getters: {
    bannerOpen: (state) => {
      return state.bannerOpen;
    }
  },
}));

export default bannerStore;
